import type { ReactNode } from 'react';
import classes from './Tag.module.css';

export type TagVariant = 'neutral' | 'ok' | 'risk' | 'pending' | 'blue' | 'enc';

export interface TagProps {
  variant?: TagVariant;
  children: ReactNode;
}

export function Tag({ variant = 'neutral', children }: TagProps) {
  const variantClass = variant === 'neutral' ? '' : ` ${classes[variant]}`;
  return <span className={`${classes.tag}${variantClass}`}>{children}</span>;
}
